import { createBroadcastEvent } from '@h5s/util-broadcast';

export const REQUIRED_UPDATE_EVENT = createBroadcastEvent('REQUIRED_UPDATE_EVENT');
